import type { IPageSortOption } from '@/types';
import type { DataTableHeader } from '@/types/vuetify';

function headerLookupKey(h: DataTableHeader): string | null {
    if (typeof h.key === 'string' && h.key !== '') return h.key;
    if (typeof h.value === 'string' && h.value !== '') return h.value;
    return null;
}

export function mapPageSortByForListApi(sortBy: IPageSortOption[], headers: DataTableHeader[]): IPageSortOption[] {
    const byColumnKey = new Map<string, DataTableHeader>();
    for (const h of headers) {
        const k = headerLookupKey(h);
        if (k) byColumnKey.set(k, h);
    }
    return sortBy.map((s) => {
        const header = byColumnKey.get(s.key);
        const override = header?.customSortKey;
        return {
            key: typeof override === 'string' && override !== '' ? override : s.key,
            order: s.order,
        };
    });
}
